import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

// إنشاء سياق إحصائيات الطلبات
const StatisticsContext = createContext(null);

export const StatisticsProvider = ({ children }) => {
  const { token } = useAuth();
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  // Create authenticated axios instance
  const getAuthenticatedAxios = () => {
    const axiosInstance = axios.create();
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return axiosInstance;
  };

  // دالة لجلب بيانات تحليلات الطلبات
  const fetchOrdersAnalytics = async (startDate = '', endDate = '') => {
    try {
      setLoading(true);
      
      // بناء عنوان URL مع معلمات الاستعلام
      let url = '/api/orders-analytics';
      const params = new URLSearchParams();
      
      if (startDate) {
        params.append('start_date', startDate);
      }
      
      if (endDate) {
        params.append('end_date', endDate);
      }
      
      // إضافة معلمات الاستعلام إلى عنوان URL إذا كانت موجودة
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const axiosAuth = getAuthenticatedAxios();
      const response = await axiosAuth.get(url);
      setAnalyticsData(response.data);
      setError(null);
    } catch (err) {
      setError('فشل في تحميل بيانات تحليلات الطلبات');
      console.error('Orders analytics error:', err);
    } finally {
      setLoading(false);
    }
  };

  // تحديث نطاق التاريخ
  const updateDateRange = (startDate, endDate) => {
    setDateRange({ startDate, endDate });
    fetchOrdersAnalytics(startDate, endDate);
  };

  // القيم التي سيتم توفيرها عبر السياق
  const contextValue = {
    analyticsData,
    loading,
    error,
    dateRange,
    fetchOrdersAnalytics,
    updateDateRange
  };

  return (
    <StatisticsContext.Provider value={contextValue}>
      {children}
    </StatisticsContext.Provider>
  );
};

// هوك مخصص لاستخدام سياق الإحصائيات
export const useStatistics = () => {
  const context = useContext(StatisticsContext);
  if (!context) {
    throw new Error('useStatistics يجب أن يستخدم داخل StatisticsProvider');
  }
  return context;
};